import { render, staticRenderFns } from "./AuthMessageSent.vue?vue&type=template&id=2b1569c8&"
import script from "./AuthMessageSent.vue?vue&type=script&lang=js&"
export * from "./AuthMessageSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports